(ns notification.views
  (:require
    [very.re-frame.core :as rf]
    [css.vars :as vars]
    [css.core :refer [defstyled]]))

(defstyled message-wrapper-s :div
  {:background-color (with-meta #(condp = %
                                   :error vars/red
                                   :success vars/green) :status)
   :position "absolute"
   :padding "1rem 2rem"
   :width "100%"})

(defstyled message-s :div
  {:color "white"
   :text-align "center"})

(defstyled message-icon-s :span
  {:margin-right ".5rem"})

(defstyled message-close-s :button
  {:background-color "transparent"
   :background-image "url(/assets/icons/close--white.svg)"
   :background-repeat "no-repeat"
   :background-position "center"
   :background-size "1rem"
   :border "none"
   :position "absolute"
   :right "0"
   :bottom "0"
   :top "0"
   :margin "auto"
   :display "flex"
   :align-items "center"
   :padding "1rem"
   :color "white"
   :cursor "pointer"})

(defn container []
  (let [note (rf/subscribe [:notification])]
    (fn []
      (let [{:keys [message status]} @note]
        (when @note
          [message-wrapper-s {:status status}
           [message-s
            [message-icon-s]
            [:span message]]
           [message-close-s {:on-click #(rf/>evt [:remove-message])}]])))))
